module.exports = __webpack_public_path__ + "img/switzerland-stomach-cancer-female.c8cb454b.png";